import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmRovoAiAuditLogsRoute: InvariantJiraRoute = {
	name: 'products-jsm-rovo-ai-activity',
	path: '/jira/settings/products/jira-service-management-rovo-ai/activity',
	exact: true,
};
